module.exports = __webpack_public_path__ + "media/images/favicon-9ddecd0906320dd290c1ee777262548a.ico";